/**
 * @description 代理配置 - 接口地址有重叠地址时，需要将匹配度低的放在后面
 * @created 2024/04/30 09:46:37
 * @param {String} target 目标地址
 * @param {Object} pathRewrite 路径重写
 * @param {Boolean} changeOrigin 是否改变请求源
 * @param {Boolean} ws 启用websockets
 */

module.exports = {
  "/api-angwik": {
    target: "https://api.52vmy.cn/api",
    pathRewrite: { "^/api-angwik": "" },
    changeOrigin: true
  },
  "/api-oioweb": {
    target: "https://api.oioweb.cn/api",
    pathRewrite: { "^/api-oioweb": "" },
    changeOrigin: true
  },
  "/api-uomg": {
    target: "https://api.uomg.com/api",
    pathRewrite: { "^/api-uomg": "" },
    changeOrigin: true
  },
  "/api-xiaoxiao": {
    target: "https://v2.api-m.com/api",
    pathRewrite: { "^/api-xiaoxiao": "" },
    changeOrigin: true
  }
}
